import React from "react";
import {useSelector, useDispatch} from "react-redux";

import styles from "./GroupWithMiddlefacets.module.scss";
import {deactivateDependentFacets, fetchMiddlefacets, getMiddlefacetGroups} from "../../Store/Actions/NewFilterActions";
import {
    ACTIVATE_GROUP_WITH_MIDDLEFACETS, CLEAR_ACTIVE_GROUP, DEACTIVATE_FACET,
    DEACTIVATE_GROUP_WITH_MIDDLEFACETS, REMOVE_FROM_AVAILABLE_GROUPS
} from "../../Store/Actions/ActionTypes";
import MiddleFacet from "../MiddleFacet/MiddleFacet";
import getActiveMainFacetID from "../../Utils/getActiveMainFacetID";

const GroupWithMiddlefacets = (props) => {
    const {id, value, facetName} = props;
    const dispatch = useDispatch();
    const newFilterState = useSelector(state => state.newFilterReducer);
    const activeGroupWithMiddlefacets = newFilterState.activeGroupWithMiddlefacets;
    const responseCache = newFilterState.responseCache;
    const activeFilters = {...newFilterState.activeFilters};
    const activeMainFacetID = getActiveMainFacetID(newFilterState);
    const facets = {...newFilterState.facets};
    const activeMainFacet = facets[activeMainFacetID];

    const isActive = (id === activeGroupWithMiddlefacets);
    let activeMiddleFacetID = null;
    if (activeFilters[facetName] !== undefined) {
        activeMiddleFacetID = activeFilters[facetName].id;
    }

    /*

    States:
    A) middle facet selected: (activeMiddleFacetID !== null)
    - Show the selected middle facet title
    - Show an X button that will de-select the middle facet

    B) Not active, no middle facet selected: (activeMiddleFacetID === null) && (isActive === false)
    This is the initial state.
    - Show the own title
    - Do not show anything below

    C) Active, no middle facet selected: (activeMiddleFacetID === null) && (isActive === true)
    - Show the own title
    - Expand the list of middle facets below
    - No other groups should be active

    Transitions:
    B --> click on it --> C
    C --> click on it --> B
    C --> select a middle facet --> A
    A --> click on the X button --> C

    */

    // Local state values;
    const A = "A";
    const B = "B";
    const C = "C";

    // Set local state.
    let localState;
    if (activeMiddleFacetID !== null) {
        localState = A;
    }
    else {
        if (isActive) {
            localState = C;
        }
        else {
            localState = B;
        }
    }

    let middleFacetsR = [];
    const hasMiddlefacets = facets[activeMainFacetID].middlefacets[id].children !== undefined;
    if (hasMiddlefacets) {
        const middlefacets = facets[activeMainFacetID].middlefacets[id].children;
        for (const [key, item] of Object.entries(middlefacets)) {
            middleFacetsR.push(<MiddleFacet key={key} id={key} value={item.value} count={item.count} facetName={facetName} />);
        }
    }

    // Set the class.
    let myClass = `${styles.wrapper}`;
    if (localState === A) {
        myClass += ` ${styles.hasselected}`;
    }
    else if (localState === C) {
        myClass += ` ${styles.active}`;
    }

    // Set the label.
    let label;
    if (localState === A) {
        label = activeFilters[facetName].value;
    }
    else {
        label = value;
    }


    const handleClick = () => {
        dispatch({type: CLEAR_ACTIVE_GROUP});

        if (localState === B) {
            dispatch({type: ACTIVATE_GROUP_WITH_MIDDLEFACETS, payload: {id: id}});
            if (facets[activeMainFacetID] !== undefined) {
                if (facets[activeMainFacetID].middlefacets[id].children === undefined) {
                    dispatch(fetchMiddlefacets(responseCache, facetName, id, activeFilters));
                }
            }
        }
        else if (localState === C) {
            dispatch({type: DEACTIVATE_GROUP_WITH_MIDDLEFACETS});
        }
    };

    const handleReset = () => {
        dispatch({type: CLEAR_ACTIVE_GROUP});

        const facetPayload = {
            id: id,
            value: value,
            facetName: facetName
        };
        dispatch({type: DEACTIVATE_FACET, payload: facetPayload});

        const filterValue = activeFilters[facetName].value;
        const middlefacetGroups = getMiddlefacetGroups(facetName, filterValue);
        const groupsPayload = {
            groups: Object.keys(middlefacetGroups)
        };
        dispatch({type: REMOVE_FROM_AVAILABLE_GROUPS, payload: groupsPayload});

        dispatch(deactivateDependentFacets(activeMainFacet, facetName, activeFilters, activeMainFacetID));
    };

    const handleKeyDown = (e) => {
        if (e.keyCode === 13) { // Handle enter
            e.target.click();
        }
    };

    return (
        <>
            <div tabIndex="0" className={myClass} onClick={handleClick} onKeyDown={handleKeyDown}>
                {label}

                { (localState === A) &&
                <div tabIndex="0" className={styles.closebutton} onClick={handleReset} onKeyDown={handleKeyDown} />
                }
            </div>



            { (localState === C) &&
                middleFacetsR
            }

        </>
    )
};

export default GroupWithMiddlefacets;